import { jsx as a, jsxs as u } from "react/jsx-runtime";
import { I as d } from "./ic_add-CT2XM2pO.mjs";
import "react";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { e as b } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as p } from "./index-BpNK5r1N.mjs";
const g = ["medium", "large", "xlarge"], y = p(["flex items-center justify-center gap-2 rounded-full py-2 tabular-nums"], {
  variants: {
    hasIcon: {
      true: "",
      false: ""
    },
    type: {
      filled_basic: "bg-fill-neutral-weak text-text-neutral-main",
      filled_blackop: "bg-opacity-black-50 text-static-white"
    },
    size: {
      xlarge: "min-h-32 typography-body-14-regular",
      large: "min-h-26 typography-body-12-regular",
      medium: "min-h-20 typography-label-10-regular"
    },
    pcSize: {
      xlarge: "pc:min-h-32 pc:typography-body-14-regular",
      large: "pc:min-h-26 pc:typography-body-12-regular",
      medium: "pc:min-h-20 pc:typography-label-10-regular"
    }
  },
  compoundVariants: [
    ...g.flatMap((e) => [
      {
        hasIcon: !0,
        size: e,
        className: {
          medium: "pl-8 pr-6",
          large: "pl-10 pr-8",
          xlarge: "pl-12 pr-10"
        }[e]
      },
      {
        hasIcon: !1,
        size: e,
        className: {
          medium: "min-w-40 px-8",
          large: "min-w-48 px-10",
          xlarge: "min-w-54 px-12"
        }[e]
      },
      {
        hasIcon: !0,
        pcSize: e,
        className: {
          medium: "pc:pl-8 pc:pr-6",
          large: "pc:pl-10 pc:pr-8",
          xlarge: "pc:pl-12 pc:pr-10"
        }[e]
      },
      {
        hasIcon: !1,
        pcSize: e,
        className: {
          medium: "pc:min-w-40 pc:px-8",
          large: "pc:min-w-48 pc:px-10",
          xlarge: "pc:min-w-54 pc:px-12"
        }[e]
      }
    ])
  ]
}), h = p("", {
  variants: {
    size: {
      xlarge: "size-14",
      large: "size-14",
      medium: "size-12"
    },
    pcSize: {
      xlarge: "pc:size-14",
      large: "pc:size-14",
      medium: "pc:size-12"
    }
  }
}), f = p("shrink-0", {
  variants: {
    type: {
      filled_basic: "hover-never:[&>div]:bg-interaction-neutral-presshover-weak1 active:[&>div]:bg-interaction-neutral-presshover-weak1 focus-visible:[&>div]:bg-interaction-neutral-presshover-weak1",
      filled_blackop: "hover-never:[&>div]:bg-opacity-black-60 active:[&>div]:bg-opacity-black-60 focus-visible:[&>div]:bg-opacity-black-60"
    }
  }
}), v = ({
  currentPage: e,
  totalPages: c,
  type: r = "filled_basic",
  size: l,
  onClickAll: i
}) => {
  const n = typeof i == "function", t = b({
    property: l,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), o = y({ type: r, hasIcon: n, ...t }), m = h({ ...t });
  return /* @__PURE__ */ a(x, { onClick: i, type: r, children: /* @__PURE__ */ u("div", { className: o, children: [
    /* @__PURE__ */ a("span", { className: "font-bold", children: e }),
    /* @__PURE__ */ a("span", { children: "/" }),
    /* @__PURE__ */ a("span", { children: c }),
    n ? /* @__PURE__ */ a("div", { className: m, children: /* @__PURE__ */ a(d, { className: "size-full" }) }) : null
  ] }) });
}, x = ({
  children: e,
  type: c,
  onClick: r
}) => {
  const l = typeof r == "function", i = f({ type: c });
  return l ? /* @__PURE__ */ a("button", { "aria-label": "전체보기", className: s(i), onClick: r, type: "button", children: e }) : /* @__PURE__ */ a("div", { className: s(["inline-flex", "shrink-0"]), children: e });
};
v.displayName = "NDS.NumberIndicator";
export {
  v as N
};
